import { Skeleton } from '@/components/ui/skeleton'
import { CANVAS_HEIGHT } from '@/routes/load-balancer/tabs/overview/diagram/config'

export const DiagramFallback = () => {
  return (
    <Skeleton
      className="w-full border rounded-lg"
      style={{ height: CANVAS_HEIGHT }}
    />
  )
}
